import React, { useState, useEffect } from "react";
import { InvoicePDFDownloadLink } from "./components/InvoicePDF";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  collection,
  getDocs,
  where,
  query,
  getCountFromServer,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../../firebase";
import { getAuth } from "firebase/auth";

const auth = getAuth();
const db = firestore;

const BillingPage = ({ currentBusinessID, userInformation }) => {
  const [access, setAccess] = useState(false);
  const [billingData, setBillingData] = useState(null);
  const [locationsInfo, setLocationsInfo] = useState([]);
  const [lokasjonerLoaded, setLokasjonerLoaded] = useState(false);
  const [toBilling, setToBilling] = useState({});
  const [sisteFakturaInfo, setSisteFakturaInfo] = useState(null);
  const [userFakturaer, setUserFakturaer] = useState([]);
  const [updateStuff, setUpdateStuff] = useState(false);

  const dummyLocations = ["Oslo S", "Bergen Stasjon", "Trondheim Torv"];
  const dummyPrice = 0;

  const generatedBillingNumber = async () => {
    const year = new Date().getFullYear();
    const fakturaRef = collection(db, "fakturaer");
    const snapshot = await getCountFromServer(fakturaRef);

    const antallFakturaer = snapshot.data().count;
    const fakturaNumber = `${year} - ${antallFakturaer + 1}`;

    return fakturaNumber;
  };

  const generateBill = async (toBillingNames) => {
    const generatedBillingNumberValue = await generatedBillingNumber();
    const newFakturaRef = doc(db, "fakturaer", generatedBillingNumberValue);
    const userRef = doc(db, "users", auth.currentUser.uid);

    const fakturaData = {
      locations: toBillingNames,
      unitPrice: dummyPrice,
      total: toBillingNames.length * dummyPrice,
      kontonr: userInformation.kontonummer,
      navn: userInformation.navn,
      orgnr: userInformation.orgnr ? userInformation.orgnr : "Ikke oppgitt",
      generatedBillingNumber: generatedBillingNumberValue,
      createdAt: new Date(),
      billSendt: true,
      billPayd: false,
      userId: auth.currentUser.uid,
    };

    await updateDoc(userRef, {
      fakturaer: [
        ...(userInformation.fakturaer || []),
        generatedBillingNumberValue,
      ],
    });
    await setDoc(newFakturaRef, fakturaData);
    console.log("Faktura opprettet:", fakturaData);

    window.location.reload();
  };

  useEffect(() => {
    document.title = "Mapli - Billing Page";
    const fetchUserData = async () => {
      if (userInformation?.moderator) {
        setAccess(true);
      }
      const sisteFaktura =
        userInformation?.fakturaer?.[userInformation?.fakturaer - 1];

      if (sisteFaktura) {
        const fakturaRef = doc(db, "fakturaer", sisteFaktura);
        const fakturaSnapshot = await getDoc(fakturaRef);
        if (fakturaSnapshot.exists()) {
          setSisteFakturaInfo(fakturaSnapshot.data());
        } else {
          console.error("Faktura not found");
        }
      }
    };
    if (userInformation !== null || userInformation !== undefined) {
      fetchUserData();
    }
  }, [userInformation]);

  useEffect(() => {
    if (currentBusinessID !== null && currentBusinessID !== undefined) {
      console.log("Fetching business data for ID:", currentBusinessID);
      fetchBusinessData();
    }
  }, [currentBusinessID]);

  const fetchBusinessData = async () => {
    if (currentBusinessID !== null && currentBusinessID !== undefined) {
      if (typeof currentBusinessID !== "string" || !currentBusinessID) {
        return;
      }

      const userBusinessInfo = doc(db, "businesses", currentBusinessID);
      const userBusinessList = await getDoc(userBusinessInfo);
      if (
        userBusinessList.data().menus !== undefined &&
        userBusinessList.data().menus.length > 0
      ) {
        fetchData(userBusinessList.data().menus);
      }
    }
  };

  const fetchUserFakturaer = async () => {
    if (userInformation?.fakturaer && userInformation.fakturaer.length > 0) {
      const fakturaPromises = userInformation.fakturaer.map(
        async (fakturaId) => {
          const fakturaRef = doc(db, "fakturaer", fakturaId);
          const fakturaSnapshot = await getDoc(fakturaRef);
          return fakturaSnapshot;
        },
      );
      const fetchedFakturaer = await Promise.all(fakturaPromises);
      setUserFakturaer(fetchedFakturaer);
      console.log("Fetched user fakturaer:", fetchedFakturaer[0].data());
    }
  };

  const fetchData = async (listData) => {
    const fetchedData = await Promise.all(
      listData.map(async (value) => {
        const docRef = doc(db, "lokasjoner", value);
        const docSnapshot = await getDoc(docRef);
        return docSnapshot;
      }),
    );

    setLokasjonerLoaded(true);
    setLocationsInfo(fetchedData);
  };

  useEffect(() => {
    fetchUserFakturaer();
  }, [userInformation]);

  const onSendBilling = async () => {
    if (Object.keys(toBilling).length === 0) {
      alert("Ingen lokasjoner valgt for fakturering.");
      return;
    }

    const billingEntries = Object.entries(toBilling).filter(
      ([_, value]) => value,
    );

    const promises = billingEntries.map(async ([key]) => {
      const locationRef = doc(db, "lokasjoner", key);
      const snapshot = await getDoc(locationRef);
      await updateDoc(locationRef, { billed: true });
      return snapshot.data().locationName;
    });

    const toBillingNames = await Promise.all(promises);

    await generateBill(toBillingNames);
  };

  const allToReview = () => {
    setToBilling((prev) => {
      const updated = { ...prev };

      for (const loc of locationsInfo) {
        const data = loc.data();

        if (data.toReview === true && data.billed !== true) {
          updated[loc.id] = true; // or toggle if desired
        }
      }

      return updated;
    });
  };

  return !access ? (
    <>Access Denied!</>
  ) : (
    <>
      {userInformation?.admin && (
        <>
          <button
            onClick={() => {
              console.log(toBilling);
            }}>
            Teste
          </button>
          <button
            onClick={() => {
              allToReview();
            }}>
            All To Review
          </button>
        </>
      )}
      <InvoicePDFDownloadLink
        locations={dummyLocations}
        unitPrice={dummyPrice}
        generatedBillingNumber={() => generatedBillingNumber()}
        kontonr={userInformation.kontonummer}
        navn={userInformation.navn}
        orgnr={userInformation.orgnr}
      />

      <h3>Ikke betalte fakturaer:</h3>
      {lokasjonerLoaded ? (
        <>
          {locationsInfo.map((lokasjonsInformasjon, rowIndex) => {
            if (
              lokasjonsInformasjon.data()?.toReview === false ||
              lokasjonsInformasjon.data()?.billed === true
            ) {
              return null; // Skip if the document does not exist
            }
            return (
              <div
                key={rowIndex}
                className='box'
                style={{ marginBottom: "15px", marginTop: "15px" }}>
                <div className='businessOverView'>
                  <label className='locationNameLabel'>
                    {lokasjonsInformasjon.data()?.locationName}
                  </label>
                  {userInformation?.moderator ? (
                    <label
                      style={{
                        color: lokasjonsInformasjon.data()?.toReview
                          ? "#52c78c"
                          : "#f9615b",
                      }}>
                      {lokasjonsInformasjon.data()?.toReview
                        ? "I Review"
                        : "Ikke I Review"}
                    </label>
                  ) : null}
                  <label>{lokasjonsInformasjon.data()?.adress || "-"}</label>
                  {/* <div> */}
                  <div
                    onClick={() => {
                      setToBilling((prev) => ({
                        ...prev,
                        [lokasjonsInformasjon.id]:
                          !prev[lokasjonsInformasjon.id],
                      }));
                    }}
                    style={{
                      backgroundColor: !toBilling[lokasjonsInformasjon.id]
                        ? "#52c78c"
                        : "#f9615b",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "5px",
                      borderRadius: "15px",
                      padding: "0px 10px",
                      cursor: "pointer",
                      color: "white",
                      textAlign: "center",
                      width: "15%",
                      height: "25px",
                    }}>
                    {toBilling[lokasjonsInformasjon.id]
                      ? "Fjern fra faktura"
                      : "Legg til i faktura"}
                  </div>
                </div>
              </div>
            );
          })}{" "}
          <button onClick={onSendBilling}>Send faktura</button>
        </>
      ) : (
        <></>
      )}
      {userInformation?.fakturaer?.length > 0 && (
        <div className='profileUserAccess'>
          <div className='box'>
            <label style={{ fontWeight: "bold" }}>Fakturaer:</label>
            {userFakturaer
              ?.slice() // lager en kopi for å unngå å mutere originalen
              .sort(
                (a, b) =>
                  b.data().createdAt.toDate() - a.data().createdAt.toDate(),
              )
              .map((value, index) => (
                <div className='historyTableRow' key={index}>
                  <div style={{ marginLeft: "5px", color: "black" }}>
                    {value.data().generatedBillingNumber}
                  </div>
                  <div style={{ marginLeft: "5px", color: "black" }}>
                    {value.data().locations?.length} Lokasjoner
                  </div>
                  <div style={{ marginLeft: "5px", color: "black" }}>
                    Faktura Sum: {value.data().total} NOK
                  </div>
                  <div style={{ marginLeft: "5px", color: "black" }}>
                    Sendt:{" "}
                    {new Date(
                      value.data().createdAt?.toDate(),
                    ).toLocaleDateString("no-NO", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })}
                  </div>
                  <div
                    style={{
                      marginLeft: "5px",
                      color: value.data().billPayd ? "#52c78c" : "#f9615b",
                    }}>
                    {value.data().billPayd ? "Betalt" : "Ikke Betalt"}
                  </div>
                  <div>
                    <InvoicePDFDownloadLink
                      locations={value.data().locations}
                      unitPrice={value.data().unitPrice}
                      generatedBillingNumber={
                        value.data().generatedBillingNumber
                      }
                      kontonr={value.data().kontonr}
                      navn={value.data().navn}
                      orgnr={value.data().orgnr}
                      createdAt={value.data().createdAt?.toDate()}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default BillingPage;
